// extracted by mini-css-extract-plugin
export default {"home":"Home_home__60OkT","title":"Home_title__bS59W"};